import { createSelector } from 'reselect';
import CompliancePredesResdesDespatchesDetailsColumns from '../../containers/CompliancePredesResdesDespatchesDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_RESDES_DESPATCHES_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_RESDES_DESPATCHES_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PREDES_RESDES_DESPATCHES_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesResdesDespatchesDetailsColumns);
